import { render, staticRenderFns } from "./BlogVideo.vue?vue&type=template&id=368c7d87&scoped=true&lang=html"
import script from "./BlogVideo.vue?vue&type=script&lang=js"
export * from "./BlogVideo.vue?vue&type=script&lang=js"
import style0 from "./BlogVideo.vue?vue&type=style&index=0&id=368c7d87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c7d87",
  null
  
)

export default component.exports